<form [formGroup]="userCollectionForm" class="flex flex-1 flex-col m-8" >
  <div class="flex flex-row">
    <div class="flex flex-col space-y-3" style="width: 700px">
      <span class="form-field-header">User collection name*</span>
      <lib-common-ui-components-text-input
        floatLabel="always"
        [required]="true"
        [hideRequiredMarker]="true"
        formControlName="name"
        placeholder="Enter a name"
      ></lib-common-ui-components-text-input>
      <span class="form-field-header">User collection description*</span>
      <lib-common-ui-components-text-input
        floatLabel="always"
        [required]="true"
        [hideRequiredMarker]="true"
        formControlName="description"
        [textArea]="true"
        placeholder="Enter a description"
      ></lib-common-ui-components-text-input>
    </div>
  </div>
  <div class="flex mt-4 flex-col space-y-3" style="width: 700px; height: 575px">
    <span class="form-field-header">Add users to this collection*</span>

    <!-- Search input with autocomplete -->
     <div class="flex flex-row items-center gap-2.5 mb-3">
    <div style="width:50%;">
      <lib-cdw-search-input
        [items]="availableUsers"
        placeholder="Search users to add"
        iconPrefix="search"
        backgroundColor="var(--color-primary-gray-50)"
        iconColor="var(--color-tertiary-blue-cta)"
        height="40px"
        displayField="name"
        secondaryField="email"
        (itemSelected)="onUserSelected($event)"
      ></lib-cdw-search-input>
    </div>

      <lib-cdw-button
        (buttonClick)="pasteEmails()"
        level="secondary"
        mode="small"
        fontFamily="Roboto, sans-serif"
        [fontColor]="grey400Color"
        fontWeight="700"
      >Paste emails</lib-cdw-button>
      <lib-cdw-button
        (buttonClick)="onOpenCsvUpload()"
        mode="small"
        level="secondary"
        fontFamily="Roboto, sans-serif"
        [fontColor]="grey400Color"
        fontWeight="700"
      >Import CSV</lib-cdw-button>
      <span class="flex-1 text-right text-[--color-primary-gray-300] font-['Source_Sans_3'] text-[16px] font-bold">{{ usersToAdd.length }} users added</span>
    </div>

    <div class="user-search-grid-container ag-theme-balham">
      <!-- Remove selected button overlay -->
      <div class="grid-header-actions" *ngIf="selectedRowIds.length > 0">
        <button class="remove-selected-btn" (click)="removeSelectedUsers()">
          Remove selected
        </button>
      </div>

      <lib-cdw-search-grid
        #userSearchGrid
        [columnDefs]="columnDefs"
        [defaultCdwColDef]="customColDefDefaults"
        [filterBarSettings]="[]"
        [cdwSearchGridDataService]="userSearchGridDataService"
        [componentId]="componentId"
        [cdwSidebarDef]="sidebarDef"
        [searchGridDataSource]="'sql'"
        [filterBySelectedColumnName]="'id'"
        [showCheckboxSelection]="true"
        [useMatIcon]="true"
        [initialPageSize]="25"
        [rowHeight]="36"
        (selectedIdsOutput)="onSelectedIdsChanged($event)"
        customHeaderFontWeight="700"
        customFirstColumnFontWeight="700"
        customRowFontWeight="400"
        noRowsOverlayText="No users added"
      ></lib-cdw-search-grid>
    </div>
  </div>

  <div class="flex flex-row space-x-4" style="width: 700px">
      <lib-cdw-button class="mr-auto" *ngIf="userCollection" (buttonClick)="onDeleteUserCollection()" level="warn">Delete User Collection</lib-cdw-button>
      <lib-cdw-button
        (buttonClick)="onCancelUserCollection()"
        level="secondary"
        fontFamily="Roboto, sans-serif"
        [fontColor]="grey400Color"
        fontWeight="700"
        class="ml-auto"
        >Cancel</lib-cdw-button
      >
      <lib-cdw-button
        (buttonClick)="onSaveUserCollection()"
        level="primary"
        [disabled]="isSaveDisabled"
        fontFamily="Roboto, sans-serif"
        [fontColor]="grey400Color"
        fontWeight="700"
        >Save User Collection</lib-cdw-button
      >
  </div>
</form>

<!-- Global hover card overlay -->
<div class="hover-card-overlay" *ngIf="cardData$ | async as cardData" [style.top.px]="(cardPosition$ | async)?.y" [style.left.px]="(cardPosition$ | async)?.x">
  <div class="hover-card-content">
    <lib-user-profile-card [user]="cardData"></lib-user-profile-card>
  </div>
</div>
